/* eslint-disable quote-props */
const organizeDishData = require('./dish-helper').organizeDishData;
const tableInfoLocalStorageKey = 'lastTableInfo';
const helper = require('./dish-helper');

import { formatMessage } from '../intl/helper';
import cartMessages from '../intl/messages/shopping-cart';
import dishMenuMessages from '../intl/messages/dish-menu';
import errorMessages from '../intl/messages/error-message';

exports.clearTableInfoInSessionStorage = () => {
  sessionStorage.removeItem(tableInfoLocalStorageKey);
};

const setTableInfoInSessionStorage = exports.setTableInfoInSessionStorage = (shopId, tableInfo) => {
  const tableInfoWrap = {
    shopId,
    tableInfo,
  };
  sessionStorage.setItem(tableInfoLocalStorageKey, JSON.stringify(tableInfoWrap));
};

const getTableInfoInSessionStorage = exports.getTableInfoInSessionStorage = shopId => {
  const json = sessionStorage.getItem(tableInfoLocalStorageKey);
  if (!json) {
    return {};
  }

  const tableInfoWrap = JSON.parse(json) || {};
  return tableInfoWrap.shopId === shopId ? tableInfoWrap.tableInfo : {};
};

exports.overWriteSessionStorage = (shopId, param) => {
  setTableInfoInSessionStorage(
    shopId,
    Object.assign(
      {},
      getTableInfoInSessionStorage(shopId),
      param,
    )
  );
};

exports.getAllDishFromUserOrderedDishList = (userOrderedDishList) => {
  if (!userOrderedDishList || !userOrderedDishList.length) {
    return [];
  }

  const result = [];
  userOrderedDishList.forEach(item => {
    [].push.apply(result, item.dishList);
  });
  return result;
};

/**
 * 验证菜品份数的有效性 份数 = 起卖份数 + n * 步长
 * @param {Array} dishList
 */
exports.validateOrderedDishCount = (dishList) => {
  const result = { valid: true, msg: '' };
  const invalidDishList = [];
  const dividedDishes = dishList.reduce((list, dish) => {
    const { order } = dish;
    if (!Array.isArray(order)) {
      return list.concat(dish);
    }

    const { name, stepNum, dishIncreaseUnit } = dish;
    return list.concat(order.map(item => ({ name, stepNum, order: item.count, dishIncreaseUnit })));
  }, []);

  const validate = (orderedDish) => {
    const { order, stepNum, dishIncreaseUnit } = orderedDish;
    const diff = order - dishIncreaseUnit;

    return diff >= 0 && diff % stepNum === 0;
  };

  dividedDishes.forEach(dish => {
    const valid = validate(dish);
    const { name } = dish;

    if (!valid && invalidDishList.indexOf(name) === -1) {
      invalidDishList.push(name);
    }
  });

  result.valid = invalidDishList.length === 0;
  if (!result.valid) {
    result.msg = formatMessage(errorMessages.modifyNumOnCartPage, { invalidDishList: invalidDishList.join(',') });
  }

  return result;
};

exports.getConfirmedOrderedDishListFromUserOrderedList = (userOrderedDishList) => {
  const result = [];
  if (!userOrderedDishList || !userOrderedDishList.length) {
    return result;
  }

  const types = {};
  const [userOrderedDish] = userOrderedDishList;
  const userInfo = userOrderedDish.userInfo;

  (userOrderedDish.dishList || []).forEach(dish => {
    const curType = types[dish.dishTypeId] || {
      dishTypeName: dish.dishTypeName,
      dishResults: [],
    };

    const order = dish.order;
    if (Array.isArray(order) && order.length > 0) {
      [].push.apply(curType.dishResults, order.map(item => {
        const _dish = Object.assign({}, dish);
        _dish.order = [item];
        return { userInfo, orderDish: organizeDishData(_dish) };
      }));
    } else {
      curType.dishResults.push({ userInfo, orderDish: organizeDishData(dish) });
    }
    types[dish.dishTypeId] = curType;
  });

  for (const name in types) {
    if (types.hasOwnProperty(name)) {
      result.push(types[name]);
    }
  }

  return result;
};


const divideDishes = exports.divideDishes = originOrderDish => {
  if (!originOrderDish || !originOrderDish.length) {
    return null;
  }

  function divideDishesFunc(dishes) {
    return [].concat.apply(
      [], dishes.map(dish => {
        if (helper.isSingleDishWithoutProps(dish)) {
          return [Object.assign({}, dish,
            { key:`${dish.id}` },
          )];
        }

        return dish.order.map((dishOrder, idx) =>
          Object.assign({}, dish,
            { key:`${dish.id}-${idx}` },
            { order:[Object.assign({}, dishOrder)] },
          )
        );
      })
    );
  }
  const dividedDishes = divideDishesFunc(originOrderDish);
  let newDividedDishes = [];
  dividedDishes.forEach(item => {
    newDividedDishes.push(Object.assign({}, (item.asMutable ? item.asMutable() : item), { marketPrice: helper.getDishPrice(item) }));
  });
  return newDividedDishes;
};

exports.getOrderDish = (originOrderDish, bool) => {
  let orderDish = [];
  if (bool) {
    (divideDishes(originOrderDish) || []).forEach((itemt, indext) => {
      let orderedChildDishes;
      if (itemt.order && itemt.order.length > 0 && itemt.order[0].groups) {
        orderedChildDishes = [].concat.apply([], itemt.order[0].groups.map(
          group => helper.getOrderedDishes(group.childInfos)
            )).filter(childDish => helper.getDishesCount([childDish]));
      }

      orderDish.push({
        dishResults: [{
          orderDish: Object.assign(
            {},
            itemt,
            {
              dishIngredientInfos:
                (itemt.order && itemt.order.length > 0 && itemt.order[0].dishIngredientInfos) ?
                  itemt.order[0].dishIngredientInfos :
                  itemt.dishIngredientInfos,
            },
            {
              propertyTypeList:
                (itemt.order && itemt.order.length > 0 && itemt.order[0].dishPropertyTypeInfos) ?
                  itemt.order[0].dishPropertyTypeInfos :
                  itemt.dishPropertyTypeInfos,
            },
            itemt.groups ? { subDishItems: orderedChildDishes } : {},
          ),
          userInfo: itemt.userInfo,
        }],
        dishTypeName: itemt.dishTypeName,
        dishTypeId: itemt.dishTypeId,
      });
    });
  } else {
    orderDish = originOrderDish;
  }

  const mergeMemoInfo = ({ dishIngredientInfos, dishPropertyTypeInfos, subDishItemsObj }) => {
    let propetiesArry = [];
    let title = '';
    let newMemo = [];
    const memoItem = [];
    const dishSubType = [];

    // 第四层，子菜的口味，做法，备注，配料
    if (dishPropertyTypeInfos && dishPropertyTypeInfos.length > 0) {
      dishPropertyTypeInfos.forEach(propertyType => {
        propetiesArry = [];
        if (propertyType.type === 3) {
          title = `${formatMessage(cartMessages.notes)}：`;
        } else {
          title = propertyType.name + '：';
        }
        // 第五层，多种口味，多种做法，多条备注
        propertyType.properties.forEach(properties => {
          if (properties.name && (properties.isChecked || propertyType.type === 4)) {
            propetiesArry.push(properties.name);
          }
        });
        // 过滤属性内容为空
        if (propetiesArry && propetiesArry.length > 0) {
          if (propertyType.type === 3) {
            memoItem.push(title + propetiesArry.join('、'));
          } else if (propertyType.type === 4) {
            dishSubType.push(propetiesArry.join('，'));
          } else {
            newMemo.push(title + propetiesArry.join('、'));
          }
        }
      });
      newMemo = newMemo.concat(memoItem);
      propetiesArry = [];
    }
    // 配料
    if (dishIngredientInfos && dishIngredientInfos.length > 0) {
      dishIngredientInfos.forEach(ingredient => {
        if (!ingredient.isChecked) {
          return;
        }
        propetiesArry.push(ingredient.name);
      });
  
      // 牛肉没被选上呢, isChecked属性问题
      if (propetiesArry.length > 0) {
        newMemo.push(`${formatMessage(dishMenuMessages.ingredients)}：` + propetiesArry.join('、'));
      }
    }

    subDishItemsObj.memo = newMemo.join(' | ');
  };

  let orderDishArry = [];
  let dishesArry = []; // 点菜信息，菜品和用户
  let subDishItemsArry = [];
  let totalDishNum = 0; // 菜品总份数

  if (orderDish) {
    orderDish.forEach(orderResult => {
      // 第一层，菜品种类
      const orderDishObj = {};
      let dishNum = 0; // 单菜数量
      dishesArry = [];
      orderDishObj.dishTypeName = orderResult.dishTypeName;
      orderDishObj.dishTypeId = orderResult.dishTypeId;
      orderResult.dishResults.forEach((dishResult, index) => {
        // 第二层，一条完整的点菜信息：用户头像，菜品信息
        const dishesObj = {};
        const dishItems = {};
        const dishMainType = [];
        subDishItemsArry = [];
        dishesObj.userPicPath = dishResult.userInfo.userPicPath;
        dishesObj.order = dishResult.orderDish.order;
        dishItems.num = 0;
        dishItems.marketPrice = dishResult.orderDish.marketPrice;
        if (dishResult.orderDish.order && dishResult.orderDish.order.length > 0) {
          dishResult.orderDish.order.forEach(item => {
            dishItems.num += item.count;
          });
        } else if (typeof(dishResult.orderDish.order) === 'number') {
          dishItems.num = dishResult.orderDish.order;
        } else {
          dishItems.num = dishResult.orderDish.num;
        }

        let memoArry = [];
        let propetiesArry = [];
        let title = '';

        dishNum += dishItems.num;
        orderDishObj.dishNum = dishNum;

        // 第三层，菜品信息，有子菜
        if (dishResult.orderDish.subDishItems && dishResult.orderDish.subDishItems.length > 0) {
          dishResult.orderDish.subDishItems.forEach(subDishItems => {
            let propertyTypeList = [];
            let dishIngredientInfos = [];
            if (subDishItems.order && subDishItems.order.length > 0 && subDishItems.order[0].dishIngredientInfos) {
              dishIngredientInfos = subDishItems.order[0].dishIngredientInfos;
            } else {
              dishIngredientInfos = subDishItems.dishIngredientInfos;
            }

            if (subDishItems.order && subDishItems.order.length > 0 && subDishItems.order[0].dishPropertyTypeInfos) {
              propertyTypeList = subDishItems.order[0].dishPropertyTypeInfos;
            } else {
              propertyTypeList = subDishItems.propertyTypeList || subDishItems.dishPropertyTypeInfos;
            }

            const subDishItemsObj = {};
            subDishItemsObj.num = 0;
            let isMemo = false;
            const memoItem = []; // 子菜口味备注配料
            let dishSubType = []; // 子菜规格

            // 此时不应该合并份数 TODO
            if (subDishItems.order && subDishItems.order.length > 0) {
              subDishItems.order.forEach(item => {
                subDishItemsObj.num += item.count;
              });
            } else if (typeof(subDishItems.order) === 'number') {
              subDishItemsObj.num = subDishItems.order;
            } else {
              subDishItemsObj.num = subDishItems.num;
            }

            memoArry = [];

            if (subDishItems.order && subDishItems.order.length > 0) {
              subDishItems.order.forEach(item => {
                const { count, dishPropertyTypeInfos, dishIngredientInfos: test } = item;
                subDishItemsObj.num = count;
                mergeMemoInfo({ dishIngredientInfos: test, dishPropertyTypeInfos, subDishItemsObj });

                const dishSubTypeStr = dishSubType && dishSubType.length > 0 ? `(${dishSubType.join('，')})` : '';

                subDishItemsObj.dishName = `${subDishItems.name}${dishSubTypeStr}`; // /${subDishItems.unitName}

                // 子菜数量大于0才算
                if (subDishItemsObj.num > 0) {
                  subDishItemsArry.push({ ...subDishItemsObj });
                }
              });
            } else {
              mergeMemoInfo({ dishIngredientInfos, dishPropertyTypeInfos: propertyTypeList, subDishItemsObj });
              const dishSubTypeStr = dishSubType && dishSubType.length > 0 ? `(${dishSubType.join('，')})` : '';
              subDishItemsObj.dishName = `${subDishItems.name}${dishSubTypeStr}`; // /${subDishItems.unitName}

              // 子菜数量大于0才算
              if (subDishItemsObj.num > 0) {
                subDishItemsArry.push(subDishItemsObj);
              }
            }
          });

          dishItems.subDishItems = subDishItemsArry;
        } else {
          let isMemo = false;
          let memoItem = [];
          // 第三层，菜品信息，无子菜
          if (dishResult.orderDish.propertyTypeList && dishResult.orderDish.propertyTypeList.length > 0) {
            dishResult.orderDish.propertyTypeList.forEach(propertyTypeMain => {
              propetiesArry = [];
              isMemo = true;
              if (propertyTypeMain.type === 3) {
                title = `${formatMessage(cartMessages.notes)}：`;
              } else {
                title = propertyTypeMain.name + '：';
              }

              // 第四层，多种口味，多种做法，多条备注
              propertyTypeMain.properties.forEach(propertiesMain => {
                if (!propertiesMain.isChecked) {
                  return;
                }
                propetiesArry.push(propertiesMain.name);
              });

              // 过滤属性内容为空
              if (propetiesArry && propetiesArry.length > 0) {
                if (propertyTypeMain.type === 3) {
                  memoItem.push(title + propetiesArry.join('、'));
                } else if (propertyTypeMain.type === 4) {
                  dishMainType.push(propetiesArry.join('，'));
                } else if (propertyTypeMain.type === 2) {
                  memoArry = [];
                } else {
                  memoArry.push(title + propetiesArry.join('、'));
                }
              }
            });

            memoArry = memoArry.concat(memoItem);
            propetiesArry = [];
          }

          // 配料
          if (dishResult.orderDish.dishIngredientInfos && dishResult.orderDish.dishIngredientInfos.length > 0) {
            dishResult.orderDish.dishIngredientInfos.forEach(ingredientMain => {
              if (!ingredientMain.isChecked) {
                return;
              }
              propetiesArry.push(ingredientMain.name);
            });
            if (isMemo && propetiesArry.length > 0) {
              memoArry.splice(1, 0, `${formatMessage(dishMenuMessages.ingredients)}：` + propetiesArry.join('、'));
            } else if (propetiesArry.length > 0) {
              memoArry.push(`${formatMessage(dishMenuMessages.ingredients)}：` + propetiesArry.join('、'));
            }
          }
          dishItems.memo = memoArry.join(' | ');
        }


        const dishMainTypeStr = dishMainType && dishMainType.length > 0 ? `(${dishMainType.join('，')})` : '';
        dishItems.dishName = `${dishResult.orderDish.name}${dishMainTypeStr}`;
        dishesObj.dishItems = dishItems;
        // 主菜数量大于0才算
        if (dishItems.num > 0) {
          dishesArry.push(dishesObj);
        }
      });

      totalDishNum += dishNum;
      orderDishObj.dishes = dishesArry;
      orderDishArry.push(orderDishObj);
    });
  }
  return { totalNum: totalDishNum, orderDishItems: orderDishArry };
};

exports.doClearSocketShoppingCart = (args) => {
  const { setToastProps, userInfo, tradeDetailUncheckURL } = args;
  if (userInfo.clearType === 'DEFAULT') {
    setToastProps({
      mainMessage: formatMessage(errorMessages.clearedCart),
      buttonProp: { text: formatMessage(cartMessages.known) },
      onBtnTap:() => setToastProps(null),
      imgProp: userInfo.userPicPath,
      userName: userInfo.userNickname,
    });
    return;
  }

  if (userInfo.clearType === 'ORDER_SUCCESS') {
    if (userInfo.orderId === 0) {
      // console.log('orderId等于0的情况');
      return;
    }
    setToastProps({
      mainMessage: formatMessage(errorMessages.submittedOrder),
      viceMessage: formatMessage(errorMessages.entringOrderDetailPage),
      imgProp: userInfo.userPicPath,
      userName: userInfo.userNickname,
    });

    setTimeout(() => {
      location.href = tradeDetailUncheckURL;
    }, 2000);
    return;
  }
};



// WEBPACK FOOTER //
// ./src/helper/order-dinner-cart-helper.js